// extracted by mini-css-extract-plugin
module.exports = {"lineClamp1":"utils-line-clamp-lineClamp1-c9c74c40","lineClamp2":"utils-line-clamp-lineClamp2-f1863703","lineClamp3":"utils-line-clamp-lineClamp3-d00deb14"};